import { Bankguarantee } from '@/app/bankguarantee/entities/bankguarantee.entity'

export interface BankguaranteeState {
    bankguarantees: Bankguarantee[]
}

export const state: BankguaranteeState = {
    bankguarantees: []
}
